// Import Libraries
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { FullStory } from '@fullstory/browser';
import { isMobile } from 'react-device-detect';

const LogUserIn = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    FullStory('trackEvent', {
      name: 'LoginOrSignup',
    });

    const isSystemBrowser =
      window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;

    if (isMobile && !isSystemBrowser) {
      window.open('/login', '_system');
      loginWithRedirect();
    } else {
      loginWithRedirect();
    }
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#1a1161',
        zIndex: 999999,
      }}
    ></div>
  );
};

export default LogUserIn;
